export default "__VITE_ASSET__CRTJUknZ__"